<template>
  <combobox-base
    @input="$emit('input', $event)"
    :query="query"
    :itemsGetter="itemsGetter"
    :value="value"
    label="Zameranie"
  ></combobox-base>
</template>

<script>
import {
  useCompanyFocusesQuery,
  CompanyFocusesQuery,
} from "@/generated/backend";
import { useResult } from "@vue/apollo-composable";
import ComboboxBase from "./ComboboxBase.vue";
import { useCompanyPilverFocusesQuery } from "../../generated/backend";
export default {
  components: { ComboboxBase },
  props: {
    value: { type: String },
    type: { type: String },
  },
  setup(props) {
    return {
      query: (v) =>
        props.type === "Pilver"
          ? useCompanyPilverFocusesQuery()
          : useCompanyFocusesQuery(),
      itemsGetter: (result) =>
        props.type === "Pilver"
          ? useResult(result, [], (d) => d.companyPilverFocuses)
          : useResult(result, [], (d) => d.companyFocuses),
    };
  },
};
</script>
<style></style>
